module.exports = __webpack_public_path__ + "static/media/behance.87fa23ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/FixedIcons/assets/behance.svg
// module id = 67
// module chunks = 0